class Search {
    constructor(container) {
        this.container = container;
        this.content = this.container.querySelector('.content');
        this.items = this.container.querySelectorAll('.content > *');
        this.field = this.container.querySelector('input[type="search"]');
    }

    init() {
        this.inputHandler();
    }

    inputHandler() {
        this.field.addEventListener('input', (e) => {
            const value = e.target.value.toLowerCase();

            this.hideAllElements();
            this.search(value);
        })
    }

    search(value) {
        this.items.forEach( item => {
            const searchItem = item.querySelector('.search-item').textContent.toLowerCase();

            if (searchItem.indexOf(value) > -1) {
                this.show(item);
            }
        });
    }

    show(elem) {
        elem.classList.replace('hidden', 'flex');
    }

    hideAllElements() {
        this.items.forEach( item => {
            item.classList.remove('flex');
            item.classList.add('hidden');
        });
    }
}

export default Search;
